import { IntegrationCard } from './IntegrationCard';
import { Row } from './Row';
import { Logo } from './Logo';
import { Name } from './Name';
import { Badge } from './Badge';
import { Description } from './Description';
import { Content } from './Content';
import { LogoWrapper } from './LogoWrapper';
IntegrationCard.displayName = "IntegrationCardBase";
Row.displayName = "IntegrationCard.Row";
Logo.displayName = "IntegrationCard.Logo";
Name.displayName = "IntegrationCard.Name";
Badge.displayName = "IntegrationCard.Badge";
Description.displayName = "IntegrationCard.Description";
Content.displayName = "IntegrationCard.Content";
LogoWrapper.displayName = "IntegrationCard.LogoWrapper";
export { IntegrationCard as default, Row, Content, Badge, LogoWrapper, Logo, Name, Description };